import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
import { AmbientLight } from './AmbientLight';
import { ScrollBacklight } from './ScrollBacklight';
import { useLanguage } from '../context/LanguageContext';
export function AboutTarta() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="relative overflow-hidden py-32 lg:py-48 bg-texture-espresso text-cream border-y border-cream/5" data-id="element-19" data-mp="f8jyxxvzdts0">
      <AmbientLight variant="split" data-id="element-20" data-mp="1c6upqggjovh" />
      <div className="relative z-10 max-w-[1200px] mx-auto px-8 lg:px-14" data-id="element-21" data-mp="6970s1db4rml">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="grid lg:grid-cols-12 gap-12 lg:gap-20" data-id="element-22" data-mp="3oejrkxhacomw">
          {/* Left rail — eyebrow, headline, portrait */}
          <div className="lg:col-span-5" data-id="element-23" data-mp="3dcxd3hk2l00n">
            <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-24" data-mp="38fos797jehvp">
              <span className="w-10 h-px bg-caramel/40" data-id="element-25" data-mp="3n4unim397nyb" />
              {t.about.eyebrow}
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[58px] text-cream leading-[1.02] tracking-[-0.02em] font-light" data-id="element-26" data-mp="3i4yjimuk3wir">
              {t.about.title1}{' '}
              <span className="italic font-extralight" data-id="element-27" data-mp="2pgklw87dr27q">{t.about.title2}</span>
            </h2>

            <div className="mt-12 relative max-w-sm" data-id="element-28" data-mp="2pix9p1ztk6sp">
              <ScrollBacklight tone="caramel" data-id="element-29" data-mp="34elb6jdr6fsw" />
              <div className="absolute -inset-2 border border-cream/10" aria-hidden data-id="element-30" data-mp="2zeqlgj5prw9f" />
              <div className="relative aspect-[4/5] overflow-hidden bg-chocolate" data-id="element-31" data-mp="jmtalyixjn1a">
                <img src={IMAGES.moodBox} alt="A closed TARTA box in dramatic window light, botanical shadows falling across warm marble" className="w-full h-full object-cover" data-id="element-32" data-mp="ep18kbokmkjd" />
              </div>
            </div>
          </div>

          {/* Right — narrative */}
          <div className="lg:col-span-7" data-id="element-33" data-mp="vr6yugso8sdo">
            <div className="max-w-xl space-y-7 text-cream/65 leading-[1.9] text-[15px]" data-id="element-34" data-mp="10oyrxe51ykjg">
              {t.about.paragraphs.slice(0, 1).map((p, i) => <p key={i} className="text-cream/80 font-serif italic text-xl lg:text-2xl leading-[1.5]" data-id="element-35" data-mp="32jeqojns91p" data-mpi={i}>
                  {p}
                </p>)}

              {/* Pull quote */}
              <div className="py-2" data-id="element-36" data-mp="hpum0e8t56w0">
                <p className="font-serif italic text-caramel text-2xl lg:text-3xl leading-[1.3] border-l border-caramel/40 pl-6" data-id="element-37" data-mp="hr5yd2gbjmyq">
                  {t.about.pullQuote}
                </p>
              </div>

              {t.about.paragraphs.slice(1).map((p, i) => <p key={i} data-id="element-38" data-mp="22jtjbx32p1vr" data-mpi={i}>{p}</p>)}

              {/* Signature */}
              <div className="pt-8 flex items-center gap-4" data-id="element-39" data-mp="1yihys5z236uf">
                <span className="w-10 h-px bg-caramel/50" aria-hidden data-id="element-40" data-mp="1yizr4rill0x2" />
                <div data-id="element-41" data-mp="1tilrnxv2azan">
                  <p className="font-serif italic text-cream text-xl" data-id="element-42" data-mp="1thtwgo5dn3kw">
                    {t.about.signature}
                  </p>
                  <p className="text-[10px] tracking-[0.3em] uppercase text-caramel/80 mt-1" data-id="element-43" data-mp="1omoaxqfvzqxc">
                    {t.about.signatureRole}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}